import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { ALL_ORG_STORES_ENTRY, E360HeaderConfig } from '@enliven/angular';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private readonly stateService: StateService = inject(StateService);

  withHeader: WritableSignal<boolean> = signal(true);
  withOrgSelector: WritableSignal<boolean> = signal(false);
  withOrgStoreSelector: WritableSignal<boolean> = signal(false);

  disableOrgSelector: WritableSignal<boolean> = signal(false);
  disableOrgStoreSelector: WritableSignal<boolean> = signal(false);

  hideAllStoresEntry: WritableSignal<boolean> = signal(false);

  setHeaderConfig(config: E360HeaderConfig) {
    this.withHeader.set(config.withHeader);
    this.withOrgSelector.set(config.withOrgSelector);
    this.withOrgStoreSelector.set(config.withOrgStoreSelector);
    this.disableOrgSelector.set(!!config.disableOrgSelector);
    this.disableOrgStoreSelector.set(!!config.disableOrgStoreSelector);
    this.hideAllStoresEntry.set(!!config.hideAllStoresEntry);
    this.handleAllStoresEntry();
  }

  handleAllStoresEntry() {
    if (!this.withOrgStoreSelector()) return;

    if (this.hideAllStoresEntry()) {
      this.stateService.orgStores = this.stateService.orgStores.filter(s => s.name !== ALL_ORG_STORES_ENTRY.name);
      return;
    }

    if (!this.stateService.orgStores.some(s => s.name === ALL_ORG_STORES_ENTRY.name)) {
      this.stateService.orgStores = [ALL_ORG_STORES_ENTRY, ...this.stateService.orgStores];
    }
  }
}
